import React, { useEffect } from 'react';
import '../components/css/login.css';
import SlideContainer from '../components/slideContainer';
import FormContainer from '../components/formContainer';
import LoginPageFooter from '../components/loginFooter';

const Login = () => {
  useEffect(() => {
      document.title = 'CarePlus | Login';
  });

  return (
    <div className="login_container">
      <SlideContainer />
      <FormContainer />
      <LoginPageFooter />
      <div className="login_container_img">
      </div>
    </div>
  );
};

export default Login;